import { Component, ViewChild, ViewContainerRef } from '@angular/core';
import { AppViewReceiverConst } from 'src/app/Util/AppReceiver/AppViewReceiverConst';
import { BaseFragment } from 'src/app/View/BaseUI/BaseFragment';
import { ReserveUpdateFragmentController } from './ReserveUpdateFragmentController';
import {Router} from '@angular/router';
import {ReservationSaveDTOInterface} from '../../../../../../DTO/ReservationSaveDTOInterface';
import {MstClinicDTOInterface} from '../../../../../../DTO/MstClinicDTOInterface';
import {MstDepartmentDTOInterface} from '../../../../../../DTO/MstDepartmentDTOInterface';
import {ReserveUpdateDetailPanelComponent} from './ReserveUpdateDetail/ReserveUpdateDetailPanelComponent';
import {ReservationDetailDTOInterface} from '../../../../../../DTO/ReservationDetailDTOInterface';
import {ReserveUpdateDatePanelComponent} from './ReserveUpdateDate/ReserveUpdateDatePanelComponent';
import {MstExaminationDTOInterface} from '../../../../../../DTO/MstExaminationDTOInterface';
import {DepartmentListDTOInterface} from '../../../../../../DTO/DepartmentListDTOInterface';
import {DeviceTypeDTOInterface} from '../../../../../../DTO/DeviceTypeDTOInterface';
import {ReserveConfirmFragmentComponent} from '../ReserveCreateForm/ReserveConfirm/ReserveConfirmFragmentComponent';
import {
	ReserveConfirmDateFragmentComponent
} from '../ReserveCreateForm/ReserveConfirmDate/ReserveConfirmDateFragmentComponent';
import {ReserveAlertListDTOInterface} from '../../../../../../DTO/ReserveAlertListDTOInterface';
import {
	ReservationOnlineAgreementInsureDTOInterface
} from '../../../../../../DTO/ReservationOnlineAgreementInsureDTOInterface';
import {DateUtil} from '../../../../../../Util/DateUtil';
import {
	ReserveAgreementNoneInsureFragmentComponent
} from '../ReserveCreateForm/ReserveAgreementNoneInsure/ReserveAgreementNoneInsureFragmentComponent';
import {
	ReserveUserLimitPopoverComponent
} from '../ReserveCreateForm/ReserveConfirm/ReserveUserLimitPopover/ReserveUserLimitPopoverComponent';
import {MatDialog} from '@angular/material/dialog';
/**
 * ReserveFragmentComponent
 * 予約画面
 */
@Component({
	selector: 'app-diagnose-component',
	templateUrl: './ReserveUpdateFragmentComponent.html',
	styleUrls: ['./ReserveUpdateFragmentComponent.scss'],
})
export class ReserveUpdateFragmentComponent extends BaseFragment {


	public reserveId: number;

	public eventShowDetailView: (reserveId: number) => void;
	public user = {};

	public reserveDetail: ReservationDetailDTOInterface = {
		mstClinic: {
			name: '',
		},
		mstDoctor: {
			name: '',
		}
	} as ReservationDetailDTOInterface;


	// 予約データ
	// 子コンポーネントはこのデータを更新する
	public reserveModel: ReservationSaveDTOInterface = {
		id: 0,
		clinicId: 1,
		doctorId: 0,
		departmentId: 1,
		userId: 0,
		reservationDate: '',
		reservationFrom: '',
		reservationTo: '',
		exam: [],
		examList: [],
		memo: '',
		memoUser: '',
		cancelDate: '',
		visitType: 'FIRST',
		appointmentType: 'VISIT',
	};

	// オンライン診療保険適用外への同意
	public onlineAgreement: ReservationOnlineAgreementInsureDTOInterface = {
		userId: 0,
		agreement: 0,
		reservationId: 0,
		agreementDate: ''
	};

	// クリニックリスト
	public clinicList: Array<MstClinicDTOInterface> = [
		{id: 1, name: 'ウェルネストクリニック'},
	];

	// 初診｜再診リスト
	public visitTypeList: Array<{id: string; name: string}> = [
		{id: 'FIRST', name: '初診'},
		{id: 'AGAIN', name: '再診'},
	];

	// 来院｜オンラインリスト
	public appointmentTypeList: Array<{id: string; name: string}> = [
		{id: 'VISIT', name: '来院予約'},
		{id: 'ONLINE', name: 'オンライン診療予約'}
	];

	// デバイスリスト
	public deviceTypeList: Array<DeviceTypeDTOInterface> = [];

	// 来院診療科
	public departmentVisitList: Array<DepartmentListDTOInterface> = [];

	// オンライン診療科
	public departmentOnlineList: Array<DepartmentListDTOInterface> = [];

	// 来院・オンライン・初診・再診選択時の注意事項
	public alertList: ReserveAlertListDTOInterface;

	// 画面のselectで表示するリスト
	// departmentVisitListかdepartmentOnlineListが入る
	public departmentList: Array<MstDepartmentDTOInterface> = [];

	public examList: Array<MstExaminationDTOInterface> = [
		{
			id: 0,
			name: '発熱・かぜ・その他体調不良',
			description: '',
			caution: '',
		},
	];


	// パネルのコンテナ。各機能共通
	@ViewChild('panelContainer', {read: ViewContainerRef, static: false})
	private panelContainer: ViewContainerRef;

	// イベント設定
	private TARGET_CLASS_DEF = AppViewReceiverConst.User.Fragment.ReserveFragmentComponent;
	protected EVENT_LIST: Array<Array<any>> = [
		// 画面遷移用イベント。BaseFragmentに実装されているメソッドなので注意
		// スライドイン呼び出し
		[
			this.TARGET_CLASS_DEF,
			this.TARGET_CLASS_DEF.ChangeMovePanelView,
			this.changeMovePanelView.bind(this)
		],
		// スライドインした時に消えた前パネルを戻す
		[
			this.TARGET_CLASS_DEF,
			this.TARGET_CLASS_DEF.VisiblePanelView,
			this.visibleAllViewRef.bind(this)
		],
		// スライドインを閉じる
		[
			this.TARGET_CLASS_DEF,
			this.TARGET_CLASS_DEF.CloseMovePanelView,
			this.closeMovePanelView.bind(this)
		]
	];

	// スライドイン用のコンポーネント
	@ViewChild('slideMoveBaseContainer', { read: ViewContainerRef, static: false })
	public slideMoveBaseRef: ViewContainerRef;

	// 紐付いたコントローラー
	public combineCtrl: ReserveUpdateFragmentController;

	/**
	 * constructor
	 */
	constructor(
		public router: Router,
		public dialogCtrl: MatDialog
	) {

		// Angulerのコンポーネントなので、上位を呼ぶ必要がある
		super();

		// EVENT_LISTに定義したイベントを登録する。
		this.registerEvent();

		// コントローラーの生成
		this.createController(ReserveUpdateFragmentController);
	}

	/**
	 * 開始処理
	 */
	public async start() {
		this.log('ReserveUpdateFragmentComponent::start()');
		// EVENT_LISTに定義したイベントを登録する。
		this.registerEvent();

		const initialData = await this.execFuncWithErrorHandling(
			this,
			await this.combineCtrl.getInitialData.bind(this),
			{view: this, reservationId: this.reserveId}
		);

		if (!initialData) {
			return false;
		}

		this.reserveDetail = initialData.reservation;
		this.reserveModel = initialData.reservation.reservation;
		this.user = initialData.reservation.user;
		this.clinicList = initialData.clinicList;
		this.departmentOnlineList = initialData.departmentOnlineList;
		this.departmentVisitList = initialData.departmentVisitList;
		this.visitTypeList = initialData.visitTypeList;
		this.appointmentTypeList = initialData.appointmentTypeList;
		this.deviceTypeList = initialData.deviceTypeList;
		this.alertList = initialData.alertList;

		this.onlineAgreement.agreement = this.reserveModel.onlineInsure;
		this.onlineAgreement.agreement = this.reserveModel.onlineInsureAgreement;

		await this.openUpdateDetailView();
	}

	/**
	 * 予約内容変更初期画面表示
	 */
	public async openUpdateDetailView(): Promise<any> {
		this.panelContainer.remove();

		await this.createStartWithInitialDataComponent(ReserveUpdateDetailPanelComponent, this.panelContainer, (comp: ReserveUpdateDetailPanelComponent) => {
			// 子コンポーネントでの予約データ変更を親に戻す
			comp.eventSetReserveSaveData = this.setReserveSaveData.bind(this);
			// 日時選択画面
			comp.eventSelectDate = this.openUpdateDateView.bind(this);

			comp.reserveDetail = this.reserveDetail;
			comp.reserveModel = this.reserveModel;
			comp.visitTypeList = this.visitTypeList;
			comp.appointmentTypeList = this.appointmentTypeList;
			comp.departmentVisitList = this.departmentVisitList;
			comp.departmentOnlineList = this.departmentOnlineList;
			comp.deviceTypeList = this.deviceTypeList;
			comp.alertList = this.alertList;

			comp.eventShowDetailView = this.eventShowDetailView.bind(this);
		});

	}

	/**
	 * 日時選択画面の表示
	 */
	public async openUpdateDateView(): Promise<any> {

		this.panelContainer.remove();

		this.createStartWithInitialDataComponent(ReserveUpdateDatePanelComponent, this.panelContainer, (comp: ReserveUpdateDatePanelComponent) => {
			// 予約データセット
			comp.eventSetReserveSaveData = this.setReserveSaveData.bind(this);
			// 予約更新処理イベント
			comp.eventUpdateReserve = this.updateReserve.bind(this);
			// 確認画面表示イベント
			comp.eventConfirmDate = this.openConfirmDateView.bind(this);

			// 初期画面表示
			comp.eventStart = this.openUpdateDetailView.bind(this);

			// 予約データ引き渡し
			comp.reserveModel = this.reserveModel;
		});

	}

	/**
	 * 予約日時確認画面の表示
	 * @param reserve
	 */
	public async openConfirmDateView(reserve: ReservationSaveDTOInterface): Promise<any> {
		this.panelContainer.remove();
		this.createStartWithInitialDataComponent(ReserveConfirmDateFragmentComponent, this.panelContainer, (comp: ReserveConfirmDateFragmentComponent) => {
			comp.eventSetReserveSaveData = this.setReserveSaveData.bind(this);
			comp.eventSaveReservation = this.updateReserve.bind(this);
			comp.eventSelectDate = this.openUpdateDateView.bind(this);
			comp.eventConfirm = this.openConfirmView.bind(this);
			comp.eventGotoNext = this.openConfirmView.bind(this);
			comp.reserveModel = this.reserveModel;
			comp.isUserLoggedIn = true;
		});

	}

	/**
	 * 予約内容確認・注意事項表示
	 * @param reserve
	 */
	public async openConfirmView(reserve: ReservationSaveDTOInterface): Promise<any> {

		this.panelContainer.remove();

		const agreementList = await this.execFuncWithErrorHandling(
			this,
			await this.combineCtrl.getAgreement.bind(this),
			{view: this, reserve: this.reserveModel}
		);

		if (!agreementList) {
			return;
		}

		if (this.reserveModel.appointmentType === 'ONLINE' && this.onlineAgreement.agreement === 0) {
			await this.openAgreementNoneInsureView(this.reserveModel);
			return;
		}

		this.createStartWithInitialDataComponent(ReserveConfirmFragmentComponent, this.panelContainer, (comp: ReserveConfirmFragmentComponent) => {
			comp.eventSetReserveSaveData = this.setReserveSaveData.bind(this);
			comp.eventSaveReservation = this.updateReserve.bind(this);
			comp.eventSelectDate = this.openUpdateDateView.bind(this);
			comp.agreementList = agreementList;
			comp.reserveModel = this.reserveModel;
		});

	}

	/**
	 * 予約データを保存
	 * この関数を子コンポーネントに渡して子から更新する
	 * @param reserve
	 */
	public async setReserveSaveData(reserve: ReservationSaveDTOInterface): Promise<any> {

		for (const clinic of this.clinicList) {
			if (clinic.id === this.reserveModel.clinicId) {
				this.reserveModel.clinicName = clinic.name;
			}
		}

		for (const visit of this.visitTypeList) {
			if (visit.id === this.reserveModel.visitType) {
				this.reserveModel.visitTypeName = visit.name;
			}
		}

		for (const ap of this.appointmentTypeList) {
			if (ap.id === this.reserveModel.appointmentType) {
				this.reserveModel.appointmentTypeName = ap.name;
			}
		}


		let departmentList = [];
		switch (this.reserveModel.appointmentType) {
			case 'VISIT':
				departmentList = this.departmentVisitList;
				break;

			case 'ONLINE':
				departmentList = this.departmentOnlineList;
				break;
		}

		// 診療科と診察内容の表示名設定
		for (const d of departmentList) {
			if (d.id === this.reserveModel.departmentId) {
				this.reserveModel.departmentName = d.name;
			}
		}
	}

	/**
	 * 予約の更新
	 * @param reserve
	 */
	public async updateReserve(reserve: ReservationSaveDTOInterface): Promise<any> {

		this.log('ReserveUpdateFragmentComponent::updateReserve()');
		const saveReserve = await this.execFuncWithErrorHandling(
			this,
			await this.combineCtrl.updateReservation.bind(this),
			{view: this, data: this.reserveModel, onlineAgreement: this.onlineAgreement}
		);

		if (!saveReserve) {
			return;
		}

		if (saveReserve.hasOwnProperty('type')) {
			await this.showDialogWindow(ReserveUserLimitPopoverComponent, {
				obj: saveReserve,
				openSelectDate: this.openUpdateDateView.bind(this)
			});
		} else {
			// 予約変更メッセージの送信
			const resultSendMessage = await this.execFuncWithErrorHandling(
				this,
				await this.combineCtrl.sendReserveUpdateMessage.bind(this),
				{view: this, reserveId: this.reserveModel.id}
			);

			await this.eventShowDetailView(reserve.id);
		}
	}


	/**
	 * 保険外負担に関する同意書への同意
	 * @param reserve
	 */
	public async openAgreementNoneInsureView(reserve: ReservationSaveDTOInterface): Promise<any> {

		this.panelContainer.remove();

		this.createStartWithInitialDataComponent(ReserveAgreementNoneInsureFragmentComponent, this.panelContainer, (comp: ReserveAgreementNoneInsureFragmentComponent) => {
			comp.reserveModel = this.reserveModel;
			comp.eventSelectDate = this.openUpdateDateView.bind(this);
			comp.eventGotoNext = this.openConfirmView.bind(this);
			comp.eventAgreeOnlineInsure = this.agreeOnlineAgreement.bind(this);
		});

	}

	/**
	 * 保険外負担に関する同意書へ同意時のデータ処理
	 */
	public async agreeOnlineAgreement(): Promise<any> {
		this.onlineAgreement.agreement =  1;
		this.onlineAgreement.agreementDate = DateUtil.getNowDateTimeString();
		return true;
	}
}

